// src/components/avatar/seasonItems.js
//
// The SEASONS (holiday) items, for the shop and the avatar maker. The list is
// seasons/seasonCatalog.json — the same file is functions/seasonCatalog.json,
// where the server reads prices and checks the season is on sale.
//
//   shop kinds   hat, wings, pet, frame                ids "ss-<season>-…"
//   maker kinds  top, glasses, sunglasses, pin,
//                hairdeco (hair), bgitem (background)  ids "av-ss-<season>-…"
//
// Anyone can open any season and try things on, all year. Buying is only
// open in the season's window (seasonOpen). Things you bought are yours to
// wear all year.

import data from "./seasons/seasonCatalog.json";
import { CATALOG } from "./avatarCatalog";
import { SEASONS, nextOpenLabel, seasonOf, seasonOpen } from "./seasons/seasonData";

export { SEASONS, nextOpenLabel, seasonOf, seasonOpen };

export const SEASON_ITEMS = data.items;
export const SEASON_BY_ID = Object.fromEntries(SEASON_ITEMS.map((i) => [i.id, i]));
export const SEASON_SHOP_KINDS = ["hat", "wings", "pet", "frame"];
export const SEASON_SHOP_ITEMS = SEASON_ITEMS.filter((i) => SEASON_SHOP_KINDS.includes(i.kind));
export const SEASON_MAKER_ITEMS = SEASON_ITEMS.filter((i) => !SEASON_SHOP_KINDS.includes(i.kind));

const bySort = (a, b) => (Number(a.sort) || 0) - (Number(b.sort) || 0) || (Number(a.price) || 0) - (Number(b.price) || 0);

/** this season's items of one kind (built-in + uploaded in the Layout Builder) */
export const seasonItemsOf = (season, kind) =>
  [...SEASON_ITEMS, ...CATALOG.filter((i) => i.live && i.season)].filter((i) => i.season === season && i.kind === kind).sort(bySort);

/** can it be bought today? (non-seasonal items always) */
export const onSaleNow = (item) => !item?.season || seasonOpen(item.season);
